<div [style]="getDynamicStyle" *ngFor="let rowControls of control.element.gridControls">
  <div class="grid-item" *ngFor="let rowControl of rowControls">
    <app-dynamic-control [formGroup]="pageFormGroup"
                         [control]="rowControl"
                         [viewModel]="viewModel"
                         [controlCache]="controls"></app-dynamic-control>
  </div>
</div>
